/**
 * Remove leading and trailing slashes from a route.
 */
export const removeLeadingTrailingSlashes = (route) => {
  return route.replace(/^\/|\/$/g, '');
};

export const pickDataProvider = (resourceName, dataProviderName, resources) => {
  if (dataProviderName) {
    return dataProviderName;
  }
  const resource = resources.find(
    ({ name }) => removeLeadingTrailingSlashes(name) === removeLeadingTrailingSlashes(resourceName)
  );
  if (!resource) return undefined;
  if (resource.meta) {
    const { dataProvider } = resource.meta;
    return dataProvider;
  }
  return 'default';
};
